import React from 'react'
import PropTypes from 'prop-types'
import { Provider, observer } from 'mobx-react'
import PhotoboothBackgroundModal from './PhotoboothBackgroundModal'
import BookNowButton from '../../ui/BookNowButton'

@observer
export default class PhotoboothBackground extends React.Component {
  static propTypes = {
    photoboothBackground: PropTypes.object.isRequired,
    showBookNowButton: PropTypes.bool.isRequired,
    bookNowButtonText: PropTypes.string.isRequired,
    showPrice: PropTypes.bool.isRequired,
    buttonBackgroundColor: PropTypes.string,
    buttonForegroundColor: PropTypes.string,
    textColor: PropTypes.string,
    style: PropTypes.any
  }

  state = {
    showModal: false
  }

  handleShow = () => {
    this.setState({ showModal: true })
  }

  handleClose = () => {
    this.setState({ showModal: false })
  }

  renderTitle() {
    const { photoboothBackground, showPrice } = this.props

    if(showPrice && photoboothBackground.attributes.priceFormatted) {
      return `${photoboothBackground.attributes.name}: ${photoboothBackground.attributes.priceFormatted}`
    }
    else {
      return photoboothBackground.attributes.name
    }
  }

  render() {
    const { photoboothBackground, style, showPrice, showTitle, showBookNowButton, bookNowButtonText, textColor, fontFamily, buttonBackgroundColor, buttonForegroundColor } = this.props
    const { showModal } = this.state

    let titleStyle = {...styles.title}
    if(textColor) {
      titleStyle.color = textColor
    }
    if(fontFamily) {
      titleStyle.fontFamily = fontFamily
    }

    return (
      <div className="cc-widget-photobooth-background" style={{...styles.container, ...style}}>
        <PhotoboothBackgroundModal
          photoboothBackground={photoboothBackground}
          showBookNowButton={showBookNowButton}
          bookNowButtonText={bookNowButtonText}
          showPrice={showPrice}
          showTitle={showTitle}
          show={showModal}
          onClose={this.handleClose}
          fontFamily={fontFamily}
        />
        <div onClick={this.handleShow}>
          { showTitle &&
            <div style={titleStyle}>
              { this.renderTitle() }
            </div>
          }
          <div>
            <img
              src={photoboothBackground.attributes.primaryImage.videoVariant}
              className="cc-widget-backdrop-image"
              style={styles.image}
            />
          </div>
        </div>
        <div style={styles.bookNowContainer}>
          <BookNowButton
            showBookNowButton={showBookNowButton}
            bookNowButtonText={bookNowButtonText}
            buttonBackgroundColor={buttonBackgroundColor}
            buttonForegroundColor={buttonForegroundColor}
            fontFamily={fontFamily}
          />
        </div>
      </div>
    )
  }
}

const styles = {
  container: {
    cursor: 'pointer'
  },
  title: {
    fontSize: 18,
    fontWeight: "bold",
    color: "#000",
    textAlign: "center"
  },
  image: {
    maxWidth: "100%",
    width: "auto",
    height: "auto"
  },
  bookNowContainer: {
    marginTop: 10,
    textAlign: "center"
  }
}
